// Auto-generated by splitter.py — do not regenerate; edit directly.

import React from 'react';
import { Check, X } from 'lucide-react';

export const Timeline = ({ items }) => (
  <div className="relative">
    {items.map((it, i) => (
      <div key={i} className="flex gap-3 pb-3 last:pb-0">
        <div className="flex flex-col items-center flex-shrink-0">
          <div className="w-2 h-2 rounded-full bg-[#1F2937] mt-1" />
          {i < items.length - 1 && <div className="w-px flex-1 bg-[#E6E4E1] mt-1" />}
        </div>
        <div className="flex-1 pb-2">
          <div className="text-[12.5px] text-[#1F2937]">
            <span className="font-medium">{it.actor}</span> {it.action}
            {it.target && <span className="font-mono text-[11.5px] ml-1 text-[#4B5563]">{it.target}</span>}
          </div>
          <div className="text-[11px] text-[#9CA3AF] mt-0.5">{it.time}</div>
        </div>
      </div>
    ))}
  </div>
);

/* ============================================================================
   PAGE: DASHBOARD
   ============================================================================ */


/* ============================================================================
   EVENT DETAIL — full workspace page (mission control)
   ============================================================================ */

